export default "__VITE_ASSET__CrawBZrg__"